// extracted by mini-css-extract-plugin
export default {"torqueDropDown":"styles_torqueDropDown__kBt7W"};